module.exports = __webpack_public_path__ + "static/media/taimalishan_package.b290ba6d.webp";